import { gql } from '@apollo/client'

export default gql`
  mutation SignDailyCheckInMakeup(
    $campaignID: String
    $missedClaimedCount: Int
  ) {
    signDailyCheckInMakeup: signDailyCheckInMakeUp(
      input: {
        campaignID: $campaignID
        missedClaimedCount: $missedClaimedCount
      }
    ) {
      walletAddress
      campaignID
      maxMakeupCount
      makeupDayCount
      animusUse
      signTimeInSec
      signature
    }
  }
`
